"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AutosizeColumn = void 0;
const debug_1 = __importDefault(require("debug"));
const _ = __importStar(require("lodash"));
const slickgrid_1 = require("slickgrid");
const helpers_1 = require("../helpers");
const log = (0, debug_1.default)('itp:slick:plugins:AutosizeColumn');
class AutosizeColumn {
    pluginName = 'AutosizeColumn';
    grid;
    unsubscribeAll;
    canvasContext;
    maxWidth;
    constructor(maxWidth = 200) {
        this.maxWidth = maxWidth;
        const cvc = document.createElement('canvas').getContext('2d');
        if (cvc) {
            this.canvasContext = cvc;
        }
    }
    init(grid) {
        this.grid = grid;
        const resizeColumnHandler = this.onResizeColumn.bind(this);
        grid.getContainerNode().addEventListener('dblclick', resizeColumnHandler);
        this.unsubscribeAll = () => grid
            .getContainerNode()
            .removeEventListener('dblclick', resizeColumnHandler);
        log('init completed. maxWidth=%s', this.maxWidth);
    }
    destroy() {
        this.unsubscribeAll();
    }
    resizeAllColumns() {
        const grid = this.grid;
        const columns = grid.getColumns();
        const cnode = Array.from(this.containerNode.getElementsByClassName('slick-header-column'));
        cnode.forEach(el => {
            const column = getColumnFromHeaderElement(grid, el);
            (0, helpers_1.assertNonNullish)(column.id, 'Column id must not be null.');
            const headerWidth = getElementWidth(el);
            if (!_.isFinite(headerWidth)) {
                console.warn(`Header width is not a number. columnId: ${column.id}, el: ${el}`);
                return;
            }
            const colIndex = grid.getColumnIndex(column.id);
            const maxColumnTextWidth = this.getMaxColumnTextWidth(column, colIndex);
            let autoSizeWidth = Math.min(this.maxWidth, Math.max(headerWidth, maxColumnTextWidth) + 1);
            if (!_.isFinite(autoSizeWidth)) {
                console.warn(`Autosize width is not a number. maxWidth: ${this.maxWidth}`);
                return;
            }
            column.width = autoSizeWidth;
            log('%s width:=%s', column.id, autoSizeWidth);
        });
        grid.setColumns(columns);
        grid.onColumnsResized.notify();
    }
    get containerNode() {
        return this.grid.getContainerNode();
    }
    onResizeColumn(e) {
        const target = e.target;
        if (!(target instanceof HTMLElement)) {
            return;
        }
        if (!target.classList.contains('slick-resizable-handle')) {
            return;
        }
        const headerEl = target.closest('.slick-header-column');
        if (!headerEl) {
            return;
        }
        const columnDef = getColumnFromHeaderElement(this.grid, headerEl);
        if (!columnDef || !columnDef.resizable) {
            return;
        }
        e.preventDefault();
        e.stopPropagation();
        const grid = this.grid, headerWidth = getElementWidth(headerEl), colIndex = grid.getColumnIndex(columnDef.id), allColumns = grid.getColumns(), column = allColumns[colIndex], autoSizeWidth = Math.max(headerWidth, this.getMaxColumnTextWidth(column, colIndex)) + 1;
        if (autoSizeWidth !== column.width) {
            column.width = autoSizeWidth;
            grid.setColumns(allColumns);
            grid.onColumnsResized.notify();
        }
    }
    getMaxColumnTextWidth(column, colIndex) {
        const rowEl = this.createRow(column);
        let data = this.grid.getData();
        if (data && _.isFunction(data.getItems)) {
            data = data.getItems();
        }
        const texts = [];
        for (let i = 0; i < data.length; i++) {
            texts.push(data[i][column.field]);
        }
        const template = this.getMaxTextTemplate(texts, column, colIndex, data, rowEl);
        const width = this.getTemplateWidth(rowEl, template);
        if (!_.isFinite(width)) {
            console.warn(`Template width is not a number. colIndex=${colIndex}`);
        }
        rowEl.remove();
        return width;
    }
    getTemplateWidth(rowEl, template) {
        for (let cell of rowEl.getElementsByClassName('slick-cell')) {
            let c = cell;
            c.innerHTML = template;
            for (let node of c.children) {
                node.style.position = 'relative';
            }
            return c.offsetWidth + 1;
        }
        console.warn(`Row element has no children.`, rowEl);
    }
    createRow(column) {
        const rowEl = slickgrid_1.Utils.createDomElement('div', { className: 'slick-row' });
        rowEl.appendChild(slickgrid_1.Utils.createDomElement('div', {
            className: 'slick-cell',
            style: {
                visibility: 'hidden',
                'text-overflow': 'initial',
                'white-space': 'nowrap'
            }
        }));
        for (let el of this.grid
            .getContainerNode()
            .getElementsByClassName('grid-canvas')) {
            el.appendChild(rowEl);
            return rowEl;
        }
        console.warn('Could not append row element: grid-canvas not found.');
    }
    deleteRow(rowEl) {
        rowEl.remove();
    }
    getMaxTextTemplate(texts, column, colIndex, data, rowEl) {
        const formatter = column.formatter;
        let max = 0;
        let maxTemplate = null;
        _.each(texts, (text, index) => {
            let template;
            if (formatter) {
                template = slickgrid_1.Utils.createDomElement('span');
                template.innerHTML = formatter(index, colIndex, text, column, data[index]);
                text = template.textContent || text;
            }
            const length = text
                ? getElementWidthUsingCanvas(this.canvasContext, rowEl, text)
                : 0;
            if (length > max) {
                max = length;
                maxTemplate = template ? template.innerText : text;
            }
        });
        return maxTemplate;
    }
}
exports.AutosizeColumn = AutosizeColumn;
function getElementWidth(element) {
    const clone = element.cloneNode(true);
    clone.style.cssText =
        'position: absolute; visibility: hidden;right: auto;text-overflow: initial;white-space: nowrap;';
    element.parentNode.insertBefore(clone, element);
    const width = clone.offsetWidth;
    clone.parentNode.removeChild(clone);
    return width;
}
function getElementWidthUsingCanvas(context, element, text) {
    const compStyles = getComputedStyle(element);
    const fontSize = compStyles.getPropertyValue('font-size');
    const fontFamily = compStyles.getPropertyValue('font-family');
    context.font = fontSize + ' ' + fontFamily;
    return context.measureText(text).width;
}
function getColumnFromHeaderElement(grid, el) {
    let result = el.dataset['column'];
    const columnId = el.dataset.columnId || el.dataset.id;
    if (!result) {
        result = _.find(grid.getColumns(), { id: columnId });
    }
    if (!result) {
        console.warn(`Column instance not found for element`, el);
    }
    return result;
}
//# sourceMappingURL=AutosizeColumn.js.map